import { Box, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { ReactElement } from "react";

import { RetoolTenDlcRegistrationsQuery } from "~frontend/__generated__/graphql";
import { FlexBox } from "~frontend/components/FlexBox";
import { useCurrentUserIsStaff } from "~frontend/providers/LoggedInUserProvider";
import { palette } from "~frontend/theme";

export const PendingTenDlcCampaigns = ({
  campaigns,
}: {
  campaigns?: RetoolTenDlcRegistrationsQuery["retoolTenDlcRegistrations"];
}): ReactElement => {
  const isStaff = useCurrentUserIsStaff();

  return (
    <>
      {(campaigns || []).map(campaign => (
        <Box
          data-testid={`pending-campaign-${campaign.id}`}
          key={campaign.id}
          p={3}
          mb={3}
          mt={3}
          sx={{ backgroundColor: palette.lightOrange }}
        >
          <FlexBox sx={{ pt: 1 }} justifyContent="space-between">
            <Box width="60%">
              <Typography variant="body1Bold" mb={1} component="p">
                10DLC Campaign Submission: Pending
              </Typography>
              <Typography variant="body2">
                Your 10DLC registration is under review. Approval typically
                takes 7-10 business days (excluding weekends), but it may take
                longer if additional verification is needed. Questions? Reach
                out to{" "}
                <a href="mailto:compliance@scaletowin.com">
                  compliance@scaletowin.com
                </a>
                .
              </Typography>
            </Box>
            <FlexBox direction="column" sx={{ width: "20%" }}>
              <Typography variant="body2">
                <strong>Submitted:</strong>{" "}
                {campaign.submittedAt
                  ? DateTime.fromMillis(campaign.submittedAt).toLocaleString()
                  : "--"}
              </Typography>
              {isStaff && (
                <Typography variant="body2">
                  <strong>Retool ID:</strong> {campaign.id}
                </Typography>
              )}
            </FlexBox>
          </FlexBox>
        </Box>
      ))}
    </>
  );
};
